import { Card } from '@material-ui/core';
import React from 'react';
import useGetUser from 'v2/hooks/useGetUser';

import AdvancedConfigsUrls from './AdvancedConfigsUrls';
import Atention from './Atention';
import CheckoutLink from './CheckoutLink';
import CheckoutSunLink from './CheckoutSunLink';
import styles from './styles';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
  classes: any;
}
const CheckoutUrls = ({ currentProduct, currentUserId, physicalProductPending, openUrlCreatorCheckout, openTrackerForm, classes }: IProps) => {
  const user = useGetUser();
  const isWhitebelt = !user?.is_elite;

  return (
    <Card className={classes.container}>
      {isWhitebelt && <CheckoutLink currentProduct={currentProduct} currentUserId={currentUserId} physicalProductPending={physicalProductPending} />}
      <CheckoutSunLink currentProduct={currentProduct} currentUserId={currentUserId} physicalProductPending={physicalProductPending} />
      <AdvancedConfigsUrls currentProduct={currentProduct} openTrackerForm={openTrackerForm} openUrlCreatorCheckout={openUrlCreatorCheckout} />
      <Atention />
    </Card>
  );
};

export default styles(CheckoutUrls) as any;
